import {
  AssociationQuery,
  AssociationState,
  mutationSchemas
} from 'v4/entities/associations/resource__shortlist/resource__shortlist.schemas';
import { defineEntityEffect } from 'v4/entities/common/defineEntityEffect';
import { UseResourceShortlistAssociationEffectsApi } from './http/resource__shortlist.http.effects';

export const createUpdateEffect = (
  useApi: UseResourceShortlistAssociationEffectsApi
) =>
  defineEntityEffect({
    type: 'update',
    requestSchema: mutationSchemas.update.request,
    responseSchema: mutationSchemas.update.response,
    useQueryFn: () => useApi().update
  })
    .withOptimisticReconciler<AssociationState, AssociationQuery>(
      config => (state, request, query) => ({
        ...state,
        results: state.results.map(item =>
          item.id === request.association_id
            ? { ...item, ...request.payload }
            : item
        )
      })
    )
    .withResponseReconciler(config => (state, request, response, query) => {
      return {
        state: {
          ...state,
          results: state.results.map(item =>
            item.id === request.association_id ? { ...item, ...response } : item
          )
        },
        shouldInvalidate: false
      };
    })
    .build();
